import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../../actions/app-modal.action';
import { AppModalConstant } from '../../../../constants/app-modal.constant';
import "./retry-modal.style.css"


class RetryModalComponent extends Component {

    onClickRetry = () => {
        const { onRetry, closeModal } = this.props
        closeModal()
        if (onRetry && typeof onRetry === 'function') {
            onRetry()
        }
    }

    closeModal = () => {
        this.props.closeModal()
    }

    render() {
        const { modalTitle, message } = this.props;
        return (
            <Fragment>
                <div className="modal-header">
                    <h3 className="retry-modal-title margin-top-0 ng-isolate-scope">{modalTitle ? modalTitle : AppModalConstant.ERROR_MODAL_TITLE}
                    <button className="retry-modal-close-btn" onClick={this.closeModal}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7744 0.355932C11.9179 0.210922 12.0496 0.115349 12.1692 0.069209C12.2889 0.0230694 12.4365 0 12.612 0C12.8353 0 13.0547 0.0659127 13.2701 0.19774C13.4855 0.329567 13.5932 0.507532 13.5932 0.731638C13.5932 0.8371 13.5613 0.942561 13.4974 1.04802C13.4336 1.15348 13.3538 1.25894 13.2581 1.36441L8.25641 6.74294L13.5932 12.5565C13.8644 12.8729 14 13.1168 14 13.2881C14 13.4991 13.8803 13.6704 13.641 13.8023C13.4017 13.9341 13.1544 14 12.8991 14C12.7236 14 12.5681 13.9703 12.4325 13.911C12.2969 13.8517 12.1413 13.7298 11.9658 13.5452L6.98803 8.12712L1.84274 13.6441C1.7151 13.7891 1.58747 13.8847 1.45983 13.9308C1.33219 13.9769 1.1886 14 1.02906 14C0.789742 14 0.558406 13.9374 0.335043 13.8121C0.11168 13.6869 0 13.5188 0 13.3079C0 13.1234 0.0957256 12.919 0.287179 12.6949L5.76752 6.80226L0.789744 1.36441C0.694017 1.25894 0.614245 1.15348 0.550427 1.04802C0.486609 0.942561 0.454701 0.8371 0.454701 0.731638C0.454701 0.507532 0.578346 0.329567 0.825641 0.19774C1.07294 0.0659127 1.30826 0 1.53162 0C1.70712 0 1.86268 0.0230694 1.99829 0.069209C2.1339 0.115349 2.2735 0.210922 2.41709 0.355932L7.05983 5.45763L11.7744 0.355932Z" fill="#696969" />
                        </svg>
                    </button>
                    </h3>
                </div>
                <div className="modal-body">
                    {message ? message : AppModalConstant.RETRY_MESSAGE}
                </div>
                <div className="modal-footer">
                    <div className="action margin-top-20">
                        <button type="button" className="btn ng-isolate-scope" onClick={this.onClickRetry} autoFocus=""> Retry
                        </button>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(closeModal())
})

const mapStateToProps = state => {
    return {
        modalTitle: state.modalInfo.activeModal.modalTitle,
        onRetry: state.modalInfo.activeModal.onRetry,
        message: state.modalInfo.activeModal.message
    }
}

export const RetryModal =  connect(mapStateToProps, mapDispatchToProps)(RetryModalComponent);